import { OverviewPage } from './OverviewPage'
import { withOverviewPage } from './withOverviewPage'

const Connected = withOverviewPage(OverviewPage)

export { Connected as OverviewPage }
